import { AddIcon, CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  FormLabel,
  HStack,
  IconButton,
  VStack,
} from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import { useFieldArray } from "react-hook-form";
import { FormContext } from "@/providers/form";
import ListChildField from "./ListChildField";

const ListFieldManager = ({
  field,
  register,
  control,
}: {
  field: any;
  register: any;
  control: any;
}) => {
  const { saveForm, values } = useContext(FormContext);

  const [isAdding, setIsAdding] = useState(false);

  const { fields, append, remove } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormProvider)
    name: field.databaseKey, // unique name for your Field Array
  });

  useEffect(() => {
    if (fields.length === 0) {
      addRecord();
    }
  }, [fields, append]);

  const addRecord = async () => {
    setIsAdding(true);
    const currentValues = values[field.databaseKey] || [];
    await saveForm({
      [field.databaseKey]: [...currentValues, {}],
    });
    append({});
    setIsAdding(false);
  };

  const removeRecord = async (index: number) => {
    const currentValues = values[field.databaseKey] || [];
    remove(index);
    await saveForm({
      [field.databaseKey]: currentValues.filter(
        (_childItem: any, childIndex: number) => childIndex !== index
      ),
    });
  };

  return (
    <VStack gap="16px" w="100%">
      {fields.map((item: any, index: number) => (
        <VStack
          key={index}
          w="100%"
          borderTopWidth="1px"
          borderColor="gray.200"
          py="24px"
          gap="16px"
        >
          <HStack w="100%" alignItems="center" justifyContent="space-between">
            <FormLabel fontSize="lg">
              {field.heading} #{index + 1}
            </FormLabel>

            {index > 0 && (
              <IconButton
                aria-label={`Remove ${field.heading}`}
                size="sm"
                onClick={() => removeRecord(index)}
                icon={<CloseIcon />}
              />
            )}
          </HStack>
          {field.children
            .filter((childField: any) => {
              if (childField.displayIf) {
                return values[field.databaseKey][index][childField.displayIf];
              }

              return true;
            })
            .map((childField: any, childFieldIndex: number) => (
              <ListChildField
                key={childField.databaseKey}
                control={control}
                field={field}
                index={index}
                childField={childField}
                childFieldIndex={childFieldIndex}
                register={register}
              />
            ))}
        </VStack>
      ))}
      <Button
        leftIcon={<AddIcon />}
        w="100%"
        fontWeight="500"
        onClick={addRecord}
        mb={4}
        isLoading={isAdding}
      >
        Add Another {field.heading}
      </Button>
    </VStack>
  );
};

export default ListFieldManager;
